import { useEffect, useRef } from 'react';
import { GlobalSearchView } from '../globalSearch.types';

interface UseGlobalSearchRecentSearchSessionParams {
  isOpen: boolean;
  view: GlobalSearchView;
  debouncedQuery: string;
  isFetching: boolean;
  hasProductCodeResults: boolean;
  addRecentSearch: (query: string) => void;
}

const useGlobalSearchRecentSearchSession = ({
  isOpen,
  view,
  debouncedQuery,
  isFetching,
  hasProductCodeResults,
  addRecentSearch,
}: UseGlobalSearchRecentSearchSessionParams) => {
  const pendingSearchRef = useRef('');

  useEffect(() => {
    if (isOpen && view === 'results' && (!isFetching || hasProductCodeResults)) {
      pendingSearchRef.current = debouncedQuery;
    }
  }, [isOpen, view, debouncedQuery, isFetching, hasProductCodeResults]);

  useEffect(() => {
    if (isOpen || !pendingSearchRef.current) {
      return;
    }
    addRecentSearch(pendingSearchRef.current);
    pendingSearchRef.current = '';
  }, [isOpen, addRecentSearch]);

  const recordRecentSearch = (term?: string) => {
    const query = term ?? pendingSearchRef.current;
    if (!query) {
      return;
    }
    addRecentSearch(query);
    pendingSearchRef.current = '';
  };

  return { recordRecentSearch };
};

export default useGlobalSearchRecentSearchSession;
